/**
 * Throws a clearer error if trying to access an uninitialised context object.
 */
export default (function (contextName, fallback) {
  return typeof Proxy === 'undefined' ? fallback : new Proxy({}, {
    get: function get(target, name) {
      throw new Error("Could not find the property \"".concat(name, "\" in the ").concat(contextName, ". ") + "Please wrap your code with the <".concat(contextName, ".Provider />."));
    }
  });
});